export var isMobile = function () { return (typeof window !== 'undefined' ? window.innerWidth <= 720 : false); };
//# sourceMappingURL=media.js.map